<template>
  <div id="app">
    <navigation />
    <router-view/>
    <footer class="grid-x">
      <div class="cell">
        <div class="grid-container">
          <h5>&copy; 2017-{{ year }} Louis Logistics</h5>
          <div class="grid-x">
            <div class="cell">
              <button type="button" :class="['button lang-switch', {'active': $i18n.locale === lang.id}]" v-for="(lang, i) in langs" :key="`Lang${i}`" @click="changeLanguage(lang.id)">{{ lang.readable }}</button>              
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
export default {
  name: 'AppRoot',
  components: {Navigation},
  metaInfo: {
    titleTemplate: '%s | Louis Logistics'
  },
  data () {
    return {
      year: new Date().getFullYear(),
      langs: [
        {id: 'th', readable: 'ภาษาไทย'}, 
        {id: 'en', readable: 'English'}
      ]
    }
  },
  methods: {
    changeLanguage (lang) {
      this.$i18n.locale = lang
      this.$router.replace({name: this.$route.name, params: {lang: lang}})
    }
  }
}
</script>


<style lang="scss">
#app {
  font-family: 'Sarabun', Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #0d3c5f;
}

footer {
  color: #fbfbfb;
  background-color: #0d3c5f;
  padding-top: 2em;
  padding-bottom: 2em;
  .lang-switch {
    padding: 0.5em 1em;
    cursor: pointer;
    &.active {
      background: #14679e;
    }
  }
}
</style>
